import Backend from 'backend';
import {inject} from 'aurelia-framework';

@inject(Backend)
export class ProductCategoryIndexScreen {
    backend;
    productCategories = [];

    constructor(backend) {
        this.backend = backend;
    }

    activate() {
        return this.refresh();
    }

    refresh() {
        return this.backend.ProductCategoryCrud_index()
            .then(result => this.productCategories = result);
    }
}
